module.exports = __webpack_public_path__ + "static/media/sanket.481095ae.jpeg";